import { notification } from 'antd';
import { IInputWithSign, InputWithSign } from '../input-with-sign/index.component';
import Decimal from 'decimal.js';
import { CSSProperties, useEffect } from 'react';
import { handleClick } from '@/modules/helpers/handler-click/index.helper';

export const InputWithSignWheelControl = ({
  value,
  onChange,
  setValue,
  label,
  postfix,
  onBlur,
  onFocus,
  min,
  max,
  float,
  step,
  placeholder,
  prefix,
  style,
  className,
  inputClassName,
}: IArgs) => {
  const minValue = min || 0;
  const onBlurValidator = () => {
    let val = value;
    if (max && max < parseFloat(val)) {
      notification.warning({
        message: `Максимальное значение для компонента '${label}' равно ${max}`,
      });
      val = String(max);
    }
    if ((min ?? 0) > parseFloat(val)) {
      notification.warning({
        message: `Минимальное значение для компонента '${label}' равно ${min}`,
      });
      val = String(min ?? 0);
    }
    setValue(val);
  };
  // console.log(min, ' = ', max)

  // useEffect(() => {
  //   const timeoutDebouncer = setTimeout(onBlurValidator, 1500);
  //   return () => {
  //     clearTimeout(timeoutDebouncer);
  //   };
  // }, [value]);

  return (
    <InputWithSign
      value={value}
      postfix={postfix}
      label={label}
      onFocus={onFocus}
      onChange={onChange}
      onClick={handleClick}
      placeholder={placeholder}
      prefix={prefix}
      float={float}
      style={style}
      onBlur={onBlur ? onBlur : min || max ? () => onBlurValidator() : null}
      className={className}
      inputClassName={inputClassName}
      onWheel={(e: any) => {
        // e.preventDefault();
        if (e.ctrlKey && float) {
          const val = new Decimal(isNaN(parseFloat(value)) ? 0 : parseFloat(value));
          e.deltaY < 0
            ? max
              ? val.toNumber() < max && setValue(String(val.plus(0.1)))
              : setValue(String(val.plus(0.1)))
            : setValue(
                String(
                  val.toNumber() > minValue ? val.minus(0.1).toFixed(1) : minValue,
                ),
              );
        } else if (e.shiftKey) {
          const val = new Decimal(isNaN(parseFloat(value)) ? 0 : parseFloat(value));
          e.deltaY < 0
            ? max
              ? val.toNumber() < max && setValue(String(val.plus(10)))
              : setValue(String(val.plus(10)))
            : setValue(String(val.toNumber() > minValue ? val.minus(10) : minValue));
        } else if (step !== undefined) {
          const val = new Decimal(isNaN(parseFloat(value)) ? 0 : parseFloat(value));
          e.deltaY < 0
            ? max
              ? val.toNumber() < max && setValue(String(val.plus(step)))
              : setValue(String(val.plus(step)))
            : setValue(
                String(
                  val.toNumber() > minValue ? val.minus(step).toFixed(1) : minValue,
                ),
              );
        } else {
          const val = new Decimal(isNaN(parseFloat(value)) ? 0 : parseFloat(value));
          e.deltaY < 0
            ? max
              ? val.toNumber() < max && setValue(String(val.plus(1)))
              : setValue(String(val.plus(1)))
            : setValue(String(val.toNumber() > minValue ? val.minus(1) : minValue));
        }
      }}
    />
  );
};

interface IArgs extends IInputWithSign {
  value: string;
  onChange: (e: any) => void;
  setValue: (val: number | string) => void;
  onBlur?: () => void;
  min?: number | null;
  max?: number | null;
  float?: boolean;
  step?: number | string | undefined;
  placeholder?: string;
  style?: CSSProperties;
  onFocus?: any;
}
